<template>
  <div class="list">
    <div class="key" @click.stop="typing('1')">1</div>
    <div class="key" @click.stop="typing('2')">2</div>
    <div class="key" @click.stop="typing('3')">3</div>
    <div class="key" @click.stop="typing('4')">4</div>
    <div class="key" @click.stop="typing('5')">5</div>
    <div class="key" @click.stop="typing('6')">6</div>
    <div class="key" @click.stop="typing('7')">7</div>
    <div class="key" @click.stop="typing('8')">8</div>
    <div class="key" @click.stop="typing('9')">9</div>
    <div class="key dot" @click.stop="typing('.')">.</div>
    <div class="key" @click.stop="typing('0')">0</div>
    <div class="key del" @click.stop="typing('')">删除</div>
  </div>
</template>
<script>
export default {
  methods: {
    /* 防止点击完成按钮左边的空白区域收起键盘 */
    fn () {},
    /* 输入 */
    typing (val) {
      this.$emit('typing', val)
    }
  }
}
</script>
<style scoped lang="stylus">
  .list {
    height: 100%;
    background #fff
    .key:active {
      background: #e2e2e2;
    }
    .key {
      box-sizing border-box
      height: 25%;
      width: 33%;
      float: left;
      border-right: .5px solid #d6d6d6;
      border-top: .5px solid #d6d6d6;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      &.del {
        font-size: 14px;
      }
    }
    .key:nth-child(1), .key:nth-child(2), .key:nth-child(3){
      border-top: none;
    }
    .key:nth-child(3n) {
      border-right: none;
    }
  }

</style>
